require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sydney-new-zealand-journal.json") })
        }
      }, "path---sydney-new-zealand-journal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sydney-new-zealand-journal!./.cache/json/sydney-new-zealand-journal.json
// module id = 383
// module chunks = 231608221292675